import React, { useContext, useEffect, useState } from "react";
import AdminSidebar from "./components/AdminSidebar";
import AdminHeader from "./components/AdminHeader";
import axios from "axios";
import { base_url } from "./components/AdminUsers";
import toast from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../context/Authcontext";
import "../../assets/AdminCss/RulesModal.css";

const normalizeKey = (str) =>
  str.toLowerCase().replace(/\s+/g, "");

const Dashboard = () => {
  const navigate = useNavigate();
  const [showRules, setShowRules] = useState(false);

  const [openMainRule, setOpenMainRule] = useState("Football");
  const [openSubRule, setOpenSubRule] = useState("bookmaker");
  const { getRoles } = useContext(AuthContext);

  const [isSidebarOpen, setIsSidebarOpen] = useState(!(window.innerWidth < 768));
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);

  const [totalUsers, setTotalUsers] = useState(0);
  const [newUsers, setNewUsers] = useState(0);
  const [totaladmins, setTotaladmins] = useState(0);
  const [totalagents, setTotalagents] = useState(0);
  const [totalSuperMasters, setTotalSuperMasters] = useState(0);
  const [totalSuperadmins, setTotalSuperadmins] = useState(0);
  const [totalMasters, setTotalMasters] = useState(0);
  const [totalSettlement, setTotalSettlement] = useState(0);
  const [totalbet, setTotalbet] = useState(0);

  const [allowedDashboardCards, setAllowedDashboardCards] = useState([]);

  useEffect(() => {
    const adminToken = localStorage.getItem("admin");

    if (!adminToken) return;

    const rulesKey = `rulesShown_${adminToken}`;

    const alreadyShown = sessionStorage.getItem(rulesKey);

    if (!alreadyShown) {
      setShowRules(true);

      // Mark as shown
      sessionStorage.setItem(rulesKey, "true");
    }
  }, []);


  const handleAcceptRules = () => {
    const adminToken = localStorage.getItem("admin");

    if (adminToken) {
      sessionStorage.setItem(
        `rulesAccepted_${adminToken}`,
        "true"
      );
    }

    setShowRules(false);
  };

  /* ---------------- DASHBOARD CARDS ---------------- */
  const DASHBOARD_CARDS = [



    {
      key: "new client",
      label: "New Client",
      valueKey: "newUsers",
      bg: "gold",
      route: "/admin/newclient",
    },

    {
      key: "Total Superadmin",
      label: "Total Superadmins",
      valueKey: "totalSuperadmins",
      bg: "#6366f1",
    },
    {
      key: "Total admin",
      label: "Total Admins",
      valueKey: "totaladmins",
      bg: "#6366f1",
    },
    {
      key: "Total SuperMaster",
      label: "Total SuperMasters",
      valueKey: "totalSuperMasters",
      bg: "#6366f1",
    },
    {
      key: "Total Master",
      label: "Total Masters",
      valueKey: "totalMasters",
      bg: "#6366f1",
    },
    {
      key: "Total agent",
      label: "Total Agents",
      valueKey: "totalagents",
      bg: "#8b5cf6",
    },
    {
      key: "Total user",
      label: "Total Users",
      valueKey: "totalUsers",
      bg: "#80e8ff",
    },
    {
      key: "Total settlement",
      label: "Total Settlement Amount",
      valueKey: "totalSettlement",
      bg: "#f59e0b",
    },
    {
      key: "Total bet Amount",
      label: "Total Bet Amount",
      valueKey: "totalbet",
      bg: "#f59e0b",
    },
  ];

  /* ---------------- VALUE MAP (NO eval) ---------------- */
  const dashboardValues = {
    newUsers,
    totaladmins,
    totalagents,
    totalSuperMasters,
    totalMasters,
    totalSuperadmins,
    totalUsers,
    totalSettlement,
    totalbet,
  };



  /* ---------------- FETCH DASHBOARD DATA ---------------- */
  useEffect(() => {
    const auth = localStorage.getItem("admin");

    const fetchDashboard = async () => {
      try {
        const res = await axios.get(
          base_url + "/api/webapi/adminDashboardData",
          {
            headers: {
              Authorization: auth,
            },
          }
        );

        console.log("dashboard data", res.data);

        if (res.data.success) {
          setTotalUsers(res.data.totalUsers || 0);
          setTotaladmins(res.data.totalAdmins || 0);
          setTotalagents(res.data.totalAgents || 0);
          setTotalSuperMasters(res.data.totalSuperMasters || 0);
          setTotalSuperadmins(res.data.totalSuperAdmins || 0);
          setTotalMasters(res.data.totalMasters || 0);
          setNewUsers(res.data.todayUserCount || 0);
          setTotalSettlement(res.data.total_settlement || 0);
          setTotalbet(res.data.total_bet || 0);
        } else {
          toast.error(res.data.message);
        }
      } catch (err) {
        console.error(err);
      }
    };
    const adminmatch = async () => {
      try {
        const res = await axios.get(
          base_url + "/api/webapi/adminMatchapi",
          {
            headers: {
              Authorization: auth,
            },
          }
        );

        console.log("adminMatchapi data", res.data);


      } catch (err) {
        console.error(err);
      }
    };

    const footballapi = async () => {
      try {
        const res = await axios.get(
          base_url + "/api/webapi/adminfootball",
          {
            headers: {
              Authorization: auth,
            },
          }
        );

        console.log("adminMatchapi data", res.data);


      } catch (err) {
        console.error(err);
      }
    };

    const tennisapi = async () => {
      try {
        const res = await axios.get(
          base_url + "/api/webapi/admintennisapi",
          {
            headers: {
              Authorization: auth,
            },
          }
        );

        console.log("adminMatchapi data", res.data);


      } catch (err) {
        console.error(err);
      }
    };

    fetchDashboard();
    adminmatch();
    footballapi();
    tennisapi();
  }, []);

  /* ---------------- FETCH ROLES / PERMISSIONS ---------------- */
  const fetchRoles = async () => {
    const auth = localStorage.getItem("admin");
    const role = localStorage.getItem("role");

    try {
      const roles = await getRoles(auth, role);
      if (!roles?.length) return;

      const roleObject = roles[0];
      const roleName = Object.keys(roleObject)[0];
      const permissionsArray = roleObject[roleName];

      const dashboardPermissionObj = permissionsArray.find(
        (p) => Object.keys(p)[0].toLowerCase() === "dashboard"
      );

      if (!dashboardPermissionObj) {
        setAllowedDashboardCards([]);
        return;
      }

      const allowedKeys = dashboardPermissionObj.dashboard.map((d) =>
        normalizeKey(d)
      );

      const filteredCards = DASHBOARD_CARDS.filter((card) =>
        allowedKeys.includes(normalizeKey(card.key))
      );

      setAllowedDashboardCards(filteredCards);
    } catch (err) {
      console.error("Role fetch error:", err);
    }
  };

  useEffect(() => {
    fetchRoles();
  }, []);

  /* ---------------- RESPONSIVE ---------------- */
  useEffect(() => {
    const handleResize = () => {
      const mobile = window.innerWidth < 768;
      setIsMobile(mobile);
      if (!mobile) setIsSidebarOpen(true);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);


  /* ---------------- RENDER ---------------- */
  return (
    <div className="wrapper">

      <div
        className={`d-flex flex-column ${!isMobile && isSidebarOpen ? "" : "open-content-wrapper"
          }`}
      >
        <div className="page-content dashboard-page">
          <div className="px-3 ">
            <div className="row dashboard-cards-row pt-4">

              {allowedDashboardCards.map((card, index) => (
                <div key={index} className="col-6 col-lg-3">
                  <div
                    className="dashboard-card"
                    onClick={() => card.route && navigate(card.route)}
                  >
                    <div className="dashboard-card-body">
                      <p className="dashboard-card-label">
                        {card.label}
                      </p>

                      <h4 className="dashboard-card-value">
                        {dashboardValues[card.valueKey] ?? 0}
                      </h4>
                    </div>
                  </div>
                </div>
              ))}

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;